import { useMutation } from '@tanstack/react-query';

import { useTRPC } from '@/shared/api';

/**
 * 서버가 받는 문의 한 건.
 *
 * 화면의 칸 이름을 그대로 쓰지 않고 서버 스키마(`crm.schema.ts`)에 맞춘다 —
 * 폼의 id 는 화면 사정으로 바뀌지만 이 이름은 계약이다.
 */
export interface InquiryAnswers {
  contactName: string;
  email: string;
  /** 동의 없이는 보낼 수 없다 — 서버도 `literal(true)` 로 막는다. */
  agreedToPrivacy: true;
  inquiryType?: string;
  organization?: string;
  phone?: string;
  headcount?: string;
  timeframe?: string;
  budgetRange?: string;
  workTypes: string[];
  workTypeOther?: string;
  message?: string;
  /** 어느 배너·케이스를 보고 왔는지. 담당자가 맥락을 갖고 연락하기 위한 값이다. */
  source?: string;
  /** 허니팟 — 사람에게 보이지 않는 칸이라 값이 있으면 자동 제출이다. 서버가 조용히 버린다. */
  homepage?: string;
}

/** 화면이 실제로 쓰는 것만 내보낸다 — 뮤테이션 객체를 그대로 주면 화면이 캐시 API 까지 손댈 수 있다. */
export interface InquirySubmission {
  submit: (answers: InquiryAnswers) => void;
  /** 보내는 중. 버튼을 잠그는 근거다 — 두 번 눌리면 같은 문의가 두 건으로 쌓인다. */
  isPending: boolean;
  /** 서버가 받았다는 사실이 곧 접수다. 화면이 따로 기억하지 않는다. */
  isSuccess: boolean;
  /** 실패 사유. 문구는 서버가 정하고 화면은 그대로 보여준다. */
  error: unknown;
}

/** 교육 문의 접수 (O-07F). */
export function useSubmitInquiry(): InquirySubmission {
  const trpc = useTRPC();
  const mutation = useMutation(trpc.crm.submitLead.mutationOptions());

  return {
    submit: (answers) => mutation.mutate(answers),
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
